import React from "react"
import { filterInputStyle, filterSelectStyle, primaryButtonStyle } from "../styles/commonStyles"
import { TYPOGRAPHY } from "../constants/theme"

const FilterBar = ({
	search,
	setSearch,
	orderIdSearch,
	setOrderIdSearch,
	searchType,
	setSearchType,
	filterStatus,
	setFilterStatus,
	filterRecurring,
	setFilterRecurring,
	filterPlan,
	setFilterPlan,
	planCountOperator,
	setPlanCountOperator,
	planCountValue,
	setPlanCountValue,
	planList,
	isPlanDropdownOpen,
	setIsPlanDropdownOpen,
	planDropdownRef,
	onSearch,
}) => {
	const handlePlanToggle = (planId) => {
		setFilterPlan((prev) => {
			if (prev.includes(planId)) {
				return prev.filter((id) => id !== planId)
			} else {
				return [...prev, planId]
			}
		})
	}

	const handleSelectAllPlans = () => {
		if (filterPlan.length === planList.length) {
			setFilterPlan([])
		} else {
			setFilterPlan(planList.map((plan) => plan.id))
		}
	}

	return (
		<div
			style={{
				background: "#f9f9f9",
				padding: "16px 20px",
				boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
				marginBottom: 24,
				borderRadius: "8px",
			}}
		>
			{/* First Row - Search */}
			<div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
				<div style={{ flex: 1 }}>
					<input
						type="text"
						placeholder="ค้นหาลูกค้า (รหัสสมาชิกหนังสือพิมพ์, ชื่อ, อีเมล)"
						value={search}
						onChange={(e) => setSearch(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								setIsPlanDropdownOpen(false)
								onSearch()
							}
						}}
						style={{
							...filterInputStyle,
							width: "100%",
						}}
					/>
				</div>
				<div style={{ flex: "0 0 160px" }}>
					<select
						value={searchType}
						onChange={(e) => setSearchType(e.target.value)}
						style={{
							...filterSelectStyle,
							width: "100%",
						}}
					>
						<option value="orderId">รหัสคำสั่งซื้อ</option>
						<option value="invoiceId">เลขใบกำกับภาษี</option>
					</select>
				</div>
				<div style={{ flex: "0 0 200px" }}>
					<input
						type="text"
						placeholder={searchType === "orderId" ? "ค้นหารหัสคำสั่งซื้อ" : "ค้นหาเลขใบกำกับภาษี"}
						value={orderIdSearch}
						onChange={(e) => setOrderIdSearch(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								setIsPlanDropdownOpen(false)
								onSearch()
							}
						}}
						style={{
							...filterInputStyle,
							width: "100%",
						}}
					/>
				</div>
			</div>

			{/* Second Row - Filters */}
			<div>
				<div
					style={{
						display: "flex",
						flexWrap: "wrap",
						gap: 12,
						alignItems: "flex-end",
						width: "100%",
					}}
				>
					{/* Plan Filter */}
					<div style={{ flex: "1 1 200px", minWidth: "200px" }}>
						<label
							style={{
								display: "block",
								fontSize: TYPOGRAPHY.fontSize.xs,
								color: "#6b7280",
								marginBottom: 4,
								fontWeight: 500,
							}}
						>
							แพ็คเกจ
						</label>
						<PlanDropdown
							filterPlan={filterPlan}
							planList={planList}
							isPlanDropdownOpen={isPlanDropdownOpen}
							setIsPlanDropdownOpen={setIsPlanDropdownOpen}
							planDropdownRef={planDropdownRef}
							onPlanToggle={handlePlanToggle}
							onSelectAll={handleSelectAllPlans}
						/>
					</div>

					{/* Status Filter */}
					<div style={{ flex: "1 1 140px", minWidth: "140px" }}>
						<label
							style={{
								display: "block",
								fontSize: TYPOGRAPHY.fontSize.xs,
								color: "#6b7280",
								marginBottom: 4,
								fontWeight: 500,
							}}
						>
							สถานะ
						</label>
						<select
							value={filterStatus}
							onChange={(e) => setFilterStatus(e.target.value)}
							style={{
								...filterSelectStyle,
								width: "100%",
							}}
						>
							<option value="all">ทั้งหมด</option>
							<option value="active">Active</option>
							<option value="inactive">Inactive</option>
							<option value="expired">Expired</option>
							<option value="grace_period">Grace Period</option>
							<option value="cancelled">Cancelled</option>
						</select>
					</div>

					{/* Recurring Filter */}
					<div style={{ flex: "1 1 140px", minWidth: "140px" }}>
						<label
							style={{
								display: "block",
								fontSize: TYPOGRAPHY.fontSize.xs,
								color: "#6b7280",
								marginBottom: 4,
								fontWeight: 500,
							}}
						>
							ประเภทการชำระ
						</label>
						<select
							value={filterRecurring}
							onChange={(e) => setFilterRecurring(e.target.value)}
							style={{
								...filterSelectStyle,
								width: "100%",
							}}
						>
							<option value="all">ทั้งหมด</option>
							<option value="true">ตัดอัตโนมัติ</option>
							<option value="false">ชำระครั้งเดียว</option>
						</select>
					</div>

					{/* Plan Count Filter */}
					{/* <div style={{ flex: "1 1 120px", minWidth: "120px" }}>
						<label
							style={{
								display: "block",
								fontSize: TYPOGRAPHY.fontSize.xs,
								color: "#6b7280",
								marginBottom: 4,
								fontWeight: 500,
							}}
						>
							จำนวนแพ็คเกจ
						</label>
						<PlanCountFilter
							planCountOperator={planCountOperator}
							setPlanCountOperator={setPlanCountOperator}
							planCountValue={planCountValue}
							setPlanCountValue={setPlanCountValue}
							onSearch={onSearch}
							setIsPlanDropdownOpen={setIsPlanDropdownOpen}
						/>
					</div> */}

					{/* Search Button */}
					<div style={{ alignSelf: "flex-end", flexShrink: 0 }}>
						<button
							onClick={onSearch}
							style={{
								...primaryButtonStyle,
								height: "40px",
								padding: "0 24px",
								fontSize: TYPOGRAPHY.fontSize.md,
								fontWeight: 600,
								minWidth: "100px",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: "6px",
							}}
						>
							ค้นหา
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

// Plan Dropdown Component
const PlanDropdown = ({ filterPlan, planList, isPlanDropdownOpen, setIsPlanDropdownOpen, planDropdownRef, onPlanToggle, onSelectAll }) => (
	<div style={{ position: "relative", width: "100%" }} ref={planDropdownRef}>
		<div
			onClick={() => setIsPlanDropdownOpen(!isPlanDropdownOpen)}
			style={{
				border: "1px solid #d1d5db",
				borderRadius: "6px",
				background: "white",
				cursor: "pointer",
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				minHeight: filterPlan.length > 1 ? "40px" : "40px",
				padding: filterPlan.length > 1 ? "6px 12px" : "8px 12px",
				fontSize: TYPOGRAPHY.fontSize.sm,
				color: "#374151",
				fontFamily: "inherit",
			}}
		>
			<div style={{ flex: 1, overflow: "hidden" }}>
				{filterPlan.length === 0 ? (
					<span>แพ็คเกจทั้งหมด</span>
				) : filterPlan.length === 1 ? (
					<span>{planList.find((p) => p.id === filterPlan[0])?.name || `Selected (${filterPlan.length})`}</span>
				) : (
					<div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
						<div
							style={{
								fontSize: TYPOGRAPHY.fontSize.xs,
								color: "#666",
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
								maxWidth: "140px",
							}}
							title={filterPlan
								.map((planId) => {
									const plan = planList.find((p) => p.id === planId)
									return plan?.name
								})
								.filter(Boolean)
								.join(", ")}
						>
							{filterPlan
								.slice(0, 2)
								.map((planId) => {
									const plan = planList.find((p) => p.id === planId)
									return plan?.name
								})
								.filter(Boolean)
								.join(", ")}
							{filterPlan.length > 2 && ` +${filterPlan.length - 2} more`}
						</div>
					</div>
				)}
			</div>
			<span style={{ marginLeft: "8px", transform: isPlanDropdownOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>▼</span>
		</div>
		{isPlanDropdownOpen && (
			<div
				style={{
					position: "absolute",
					top: "100%",
					left: 0,
					right: 0,
					background: "white",
					border: "1px solid #ddd",
					borderRadius: "4px",
					boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
					zIndex: 1000,
					maxHeight: "200px",
					overflowY: "auto",
					padding: "8px",
				}}
			>
				<div style={{ padding: "4px 8px", borderBottom: "1px solid #eee", marginBottom: "4px" }}>
					<label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "bold" }}>
						<input
							type="checkbox"
							checked={filterPlan.length === planList.length && planList.length > 0}
							onChange={onSelectAll}
							style={{ marginRight: "8px" }}
						/>
						เลือกทั้งหมด
					</label>
				</div>
				{planList.map((plan) => (
					<div key={plan.id} style={{ padding: "4px 8px" }}>
						<label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: TYPOGRAPHY.fontSize.sm }}>
							<input type="checkbox" checked={filterPlan.includes(plan.id)} onChange={() => onPlanToggle(plan.id)} style={{ marginRight: "8px" }} />
							{plan.name}
						</label>
					</div>
				))}
			</div>
		)}
	</div>
)

// Plan Count Filter Component
const PlanCountFilter = ({ planCountOperator, setPlanCountOperator, planCountValue, setPlanCountValue, onSearch, setIsPlanDropdownOpen }) => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			gap: "0px",
			border: "1px solid #d1d5db",
			borderRadius: "6px",
			overflow: "hidden",
			background: "white",
			height: "40px",
			transition: "border-color 0.2s ease",
		}}
		title="Filter by plan count (e.g., = 5, > 3, <= 10)"
	>
		<select
			value={planCountOperator}
			onChange={(e) => setPlanCountOperator(e.target.value)}
			style={{
				border: "none",
				outline: "none",
				padding: "8px 6px",
				fontSize: TYPOGRAPHY.fontSize.sm,
				backgroundColor: "transparent",
				cursor: "pointer",
				borderRight: "1px solid #d1d5db",
				height: "100%",
				minWidth: "48px",
				color: "#333",
				fontFamily: "inherit",
			}}
		>
			<option value="eq">=</option>
			<option value="gt">&gt;</option>
			<option value="gte">&gt;=</option>
			<option value="lt">&lt;</option>
			<option value="lte">&lt;=</option>
		</select>
		<input
			type="number"
			placeholder="จำนวนแพ็คเกจ"
			value={planCountValue}
			onChange={(e) => setPlanCountValue(e.target.value)}
			onKeyDown={(e) => {
				if (e.key === "Enter") {
					setIsPlanDropdownOpen(false)
					onSearch()
				}
			}}
			style={{
				border: "none",
				outline: "none",
				padding: "8px 12px",
				fontSize: TYPOGRAPHY.fontSize.sm,
				backgroundColor: "transparent",
				// width: "100px",
				height: "100%",
				color: "#333",
				fontFamily: "inherit",
				"::placeholder": {
					color: "#999",
				},
			}}
			min="0"
		/>
	</div>
)

export default FilterBar
